define('modules/lp_info/models/weight_update',['require','exports','module','backbone','env'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone"),
      config = require("env");

  module.exports = Backbone.Model.extend({
    url: function(){
      return [config.apiHost, "pages", this.id, "weights"].join("/");
    }
  });
});

